"use client";

import { useCallback, useState } from "react";

export interface FailedImagesApi {
  readonly hasFailed: (id: string) => boolean;
  readonly markFailed: (id: string) => void;
}

/** Tracks which image IDs have fired `onError` so callers can show a
 *  placeholder. Additive-only; entries are never cleared. */
export function useFailedImages(): FailedImagesApi {
  const [failedIds, setFailedIds] = useState<ReadonlySet<string>>(
    () => new Set(),
  );

  const hasFailed = useCallback(
    (id: string) => failedIds.has(id),
    [failedIds],
  );

  const markFailed = useCallback((id: string) => {
    setFailedIds((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  }, []);

  return { hasFailed, markFailed };
}
